import { render, staticRenderFns } from "./MyPrize.vue?vue&type=template&id=5269e9a0&scoped=true"
import script from "./MyPrize.vue?vue&type=script&lang=js"
export * from "./MyPrize.vue?vue&type=script&lang=js"
import style0 from "./MyPrize.vue?vue&type=style&index=0&id=5269e9a0&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5269e9a0",
  null
  
)

export default component.exports